<div id="cxAlerts"></div>
<div *ngIf="(alerts$ | async).length">
  <app-alert         
    *ngFor="let alert of alerts$ | async"
    [level]="alert.level" 
    [message]="alert.message"
    [dismissDelay]="7000"
  ></app-alert>
</div>

<div class="tw-px-6 tw-pb-4">
  <form [formGroup]="cxInteractionForm" #formDirective="ngForm" 
  (ngSubmit)="onSaveCxInteraction(formDirective)">
    <div class="tw-p-2 tw-border-b tw-border-slate-300 tw-flex">
      <div class="tw-text-2xl tw-font-semibold">CX Interactions</div>
      <button
        type="button"
        data-cy="formly-cancel-btn"
        class="cancel-form tw-ml-auto tw-text-blue-500 tw-font-semibold"
        (click)="cancelButton(formDirective)">
        Cancel
      </button>
    </div>

    <formly-form [model]="model" [fields]="fields" [options]="options" [form]="cxInteractionForm"></formly-form>
   
    <div class="tw-flex save-cx-interaction-button-wrapper">
      <button
        mat-flat-button
        class="save-cx-interaction-button"
        data-cy="cx-interaction-save"
        [disabled]="processing"
      >
        <span *ngIf="!formSaving">Save</span>
        <mat-spinner class="tw-inline-block tw-h-6 tw-w-6"
          *ngIf="formSaving"
          diameter="24">
        </mat-spinner>
      </button>
    </div>
  </form>
</div>